import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-avatar-and-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      src: _ctx.team?.picture?.pictureUrl,
      type: "teamsGroup",
      size: "sm",
      bordered: ""
    }, null, 8, ["src"]),
    _createVNode(_component_BaseSubHeading, {
      size: "large",
      weight: "400"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "team-name", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.team.name), 1)
        ])
      ]),
      _: 3
    })
  ]))
}